<style>
    .signup-page .ivu-form .ivu-form-item{
        margin-bottom: 10px;
    }
</style>

<template>
    <div class="signup-page">
        <card >
            <Alert show-icon>
                续费流程：选择学员，选择课程，填写付款金额和购买课时数，点击保存即可
            </Alert>
            <card style="margin-bottom: 10px;">
                <p slot="title">基本信息</p>
                <Button slot="extra" type="primary" @click="chooseStudent" v-if="baseForm.id === null">选择已有学员</Button>
                <Button slot="extra" type="warning" @click="clearChoosedStudent" v-if="baseForm.id !== null">清除所选</Button>
                <Form :model="baseForm" ref="baseForm" :label-width="80">
                    <Row :gutter="16">
                        <Col span="12">
                            <FormItem label="学员姓名"  class="ivu-form-item-required">
                                <Input v-model="baseForm.name" placeholder="学员姓名" :readonly="true"/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="所在校区"  class="ivu-form-item-required">
                                <Select v-model="baseForm.zoneId" :disabled="true">
                                    <Option v-for="zone in zoneList" :value="zone.id" :key="zone.id">{{ zone.name }}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="12">
                            <FormItem label="性别" >
                                <RadioGroup v-model="baseForm.sex" :disabled="true">
                                    <Radio :label="1" :disabled="!baseForm.isNewStudent">男</Radio>
                                    <Radio :label="2" :disabled="!baseForm.isNewStudent">女</Radio>
                                </RadioGroup>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="生日" >
                                <DatePicker type="date" placeholder="选择日期"
                                            format="yyyy-MM-dd" @on-change="baseForm.birth=$event"
                                            :value="baseForm.birth" :readonly="true"></DatePicker>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="12">
                            <FormItem label="联系人1姓名" >
                                <Input v-model="baseForm.linkman1" placeholder="联系人1姓名" :readonly="!baseForm.isNewStudent"/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="联系人1电话" >
                                <Input v-model="baseForm.linkman1mobile" placeholder="联系人1电话" :readonly="!baseForm.isNewStudent"/>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="12">
                            <FormItem label="联系人2姓名" >
                                <Input v-model="baseForm.linkman2" placeholder="联系人2姓名" :readonly="!baseForm.isNewStudent"/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="联系人2电话" >
                                <Input v-model="baseForm.linkman2mobile" placeholder="联系人2电话" :readonly="!baseForm.isNewStudent"/>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <FormItem label="备注">
                                <Input v-model="baseForm.remark" placeholder="备注" :readonly="true"/>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </card>
            <card style="margin-bottom: 10px;">
                <p slot="title">选择课程</p>
                <Form :label-width="80">
                    <FormItem label="选择课程"  class="ivu-form-item-required">
                        <Select v-model="payForm.courseId" style="width: 200px;" >
                            <Option v-for="(course,index) in courseList" :key="index" :value="course.id">{{course.name}}</Option>
                        </Select>
                    </FormItem>
                </Form>


            </card>
            <card style="margin-bottom: 10px;" >
                <p slot="title">支付信息</p>
                <Form :model="payForm" ref="payForm" inline :label-width="100">
                    <FormItem label="支付金额" class="ivu-form-item-required">
                        <Input placeholder="支付金额" v-model="payForm.money" style="width: 200px;"/>
                    </FormItem>
                    <FormItem label="购买课时" class="ivu-form-item-required">
                        <Input placeholder="购买课时" v-model="payForm.hours" style="width: 200px;"/>
                    </FormItem>
                    <FormItem label="付款方式"  class="ivu-form-item-required">
                        <Select v-model="payForm.paytype" style="width:120px;">
                            <Option label="微信" value="微信"></Option>
                            <Option label="支付宝" value="支付宝"></Option>
                            <Option label="现金" value="现金"></Option>
                            <Option label="银联" value="银联"></Option>
                            <Option label="其他" value="其他"></Option>
                        </Select>
                    </FormItem>
                    <FormItem label="备注 ">
                        <Input placeholder="备注" v-model="payForm.remark" style="width: 500px;"/>
                    </FormItem>
                </Form>
            </card>
            <Row type="flex" justify="center">
                <Col span="6">
                    <div style="color:#ec4343;text-align: center;margin:10px;">请确认信息填写无误</div>
                    <Button type="primary" size="large" long @click="save" :loading="saving">保存</Button>
                </Col>
            </Row>
        </card>
        <Modal v-model="studentModal" title="学员选择" width="800">
            <Form inline>
                <FormItem><Input placeholder="搜索学员" v-model="studentKeyword"/></FormItem>
                <FormItem>
                    <Button type="primary" @click="getStudentList" size="small">搜索</Button>
                </FormItem>
            </Form>
            <Table :columns="studentColumns" :data="studentData" ></Table>
            <Page :total="studentPageTotalNum" :current="studentPageCurrent" v-if="studentShowPager" show-elevator show-total
                  @on-change="studentChangePage" :page-size="20" ></Page>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
  export default {
    name: 'renew',
    data() {
      return {
        saving:false,
        studentKeyword:null,
        studentTotalPage:0,
        studentPageTotalNum:0,
        studentPageCurrent:1,
        studentModal: false,
        studentColumns: [
          {
            title:'校区',
            key:'zoneName',
            align:'center'
          },
          {
            title:'姓名',
            key:'name',
            align:'center'
          },
          {
            title:'性别',
            key:'sex',
            align:'center',
            render: (h, params) => {
              let self = this;
              let opArray = [];
              let sex = '';
              if (params.row.sex == 1){
                sex = '男'
              }else if (params.row.sex == 2){
                sex = '女';
              }
              opArray.push(h('span', {}, sex));
              return h('div', {}, opArray);
            }
          },
          {
            title:'家长',
            key:'parent',
            align:'center'
          },
          {
            title: '操作',
            align: 'center',
            render: (h, params) => {
              let self = this;
              let opArray = [];
              opArray.push(h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$api.student.getParentsList({student_id:params.row.id}).then(res=>{
                      if(res.state == 'ok'){
                        let linkman1 = '',linkman1mobile = '',linkman2 = '',linkman2mobile='';
                        if (res.parentsList.length > 0){
                          linkman1 = res.parentsList[0].name;
                          linkman1mobile = res.parentsList[0].mobile;
                        }
                        if (res.parentsList.length > 1) {
                          linkman2 = res.parentsList[1].name;
                          linkman2mobile = res.parentsList[1].mobile;
                        }

                        let zoneName = '';
                        this.zoneList.forEach(ele=>{
                          if (ele.id == params.row.zone_id){
                            zoneName = ele.name;
                            return false;
                          }
                        })

                        this.baseForm = {
                          zoneId:params.row.zone_id,
                          id: params.row.id,
                          name: params.row.name,
                          sex: params.row.sex,
                          birth: params.row.birthday,
                          remark: params.row.remark,
                          linkman1: linkman1,
                          linkman1mobile: linkman1mobile,
                          linkman2: linkman2,
                          linkman2mobile: linkman2mobile,
                        }
                      }else{
                        this.$Message.error(res.msg)
                      }
                    });
                    this.studentModal = false

                  }
                }
              }, '选择'));
              return h('div', opArray);
            }
          }
        ],
        studentData: [],
        baseForm: {
          id:null,
          name: '',
          zoneId:null,
          sex: 1,
          birth: '',
          remark: '',
          linkman1: null,
          linkman1mobile: null,
          linkman2: null,
          linkman2mobile: null,
        },
        payForm: {
          courseId:null,
          money: null,
          hours: null,
          remark:null,
          paytype:null
        },
      }
    },
    methods: {
      clearChoosedStudent(){
        this.baseForm = {
          zoneId:null,
          id: null,
          name: null,
          sex: 1,
          birth: null,
          remark: null,
          linkman1: '',
          linkman1mobile: '',
          linkman2: '',
          linkman2mobile: ''
        }
      },
      getStudentList() {
        this.studentPageTotalNum=0;
        this.studentData=[]
        let param ={
          page:this.studentPageCurrent,
          keyword:this.studentKeyword
        }
        this.$api.student.list(param).then(res=>{
          if(res.state=="ok"){
            this.studentPageTotalNum = res.data.totalRow;
            this.studentTotalPage = res.data.totalPage;
            this.studentPageCurrent = res.data.pageNumber;
            this.studentData=res.data.list;
          }else{
            this.$Message.error(res.msg)
          }
        })
      },
      studentChangePage (page) {
        this.studentPageCurrent = page;
        this.getStudentList();
      },
      chooseStudent() {
        this.getStudentList();
        this.studentModal = true;
      },

      checkData(){
        let self = this;
        if (!self.baseForm.id){
          self.$Message.error("请选择要续费的学员");
          return false;
        }
        if (!self.payForm.courseId){
          self.$Message.error("请选择要续费课程");
          return false;
        }
        if (!self.payForm.money || self.payForm.money <= 0 ){
          self.$Message.error("请输入续费金额,并且大于0");
          return false;
        }
        if (!self.payForm.hours){
          self.$Message.error("请输入续费课时数");
          return false;
        }
        if (!self.payForm.paytype){
          self.$Message.error("请选择支付方式");
          return false;
        }
        return true;
      },
      packagingFormData(){
        return {
          'pay.student_id':this.baseForm.id,
          'pay.course_id':this.payForm.courseId,
          'pay.total_money':this.payForm.money,
          'pay.class_num_buy':this.payForm.hours,
          'pay.zone_id':this.baseForm.zoneId,
          'remark':this.payForm.remark,
          'paytype':this.payForm.paytype
        }
      },
      save() {
        let self = this;
        if (self.checkData()){
          self.$Modal.confirm({
            title: '提示',
            content: '是否确定提交续费数据吗？',
            onOk: () => {
              self.saving = true;
              self.$api.student.savePay(self.packagingFormData()).then(resp=>{
                self.saving = false;
                if (resp.state == 'ok') {
                  this.$Message.info({
                    content: '续费成功',
                    onClose() {
                      self.$store.commit('closeTag',{
                        name:'renew'
                      });
                      self.$router.push({
                        name: 'home'
                      })
                    }
                  });
                } else {
                  self.$Message.error(resp.msg);
                }
              });
            },
            onCancel: () => {}
          });
        }

      }
    },
    mounted() {
    },
    computed: {
      zoneList() {
        return this.$store.state.app.zoneList
      },
      courseList() {
        return this.$store.state.app.courseList
      },
      studentShowPager : function(){
        return this.studentTotalPage > 1
      },
    }
  }
</script>
